<script lang="ts" setup>
import type { TestimonialsSectionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: TestimonialsSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl flex flex-col items-center">
    <h1 class="mb-lg">
      {{ data.title }}
    </h1>

    <div v-if="data.optIntro" class="mb-lg md:mb-3xl w-full text-center lg:w-2/5" v-html="data.optIntro" />

    <div class="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <TestimonialCard v-for="item in data.items" :key="item.id" :testimonial="item" />
    </div>
  </div>
</template>

<style scoped>

</style>
